import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getCaseNoPrincipals(params: any): AxiosPromise {
    return EndPointService.get('/occasions/without-principal', { params });
}

function getCaseNoPrincipal(id: number | string): AxiosPromise {
    return EndPointService.get(`/caseNoPrincipals/${id}`);
}

function deleteCaseNoPrincipal(id: number | string): AxiosPromise {
    return EndPointService.delete(`/caseNoPrincipals/${id}`);
}

function createCaseNoPrincipal(payload: any): AxiosPromise {
    return EndPointService.post('/caseNoPrincipals', payload);
}

function updateCaseNoPrincipal(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/caseNoPrincipals/${id}`, { ...payload });
}

export default {
    getCaseNoPrincipals,
    getCaseNoPrincipal,
    deleteCaseNoPrincipal,
    createCaseNoPrincipal,
    updateCaseNoPrincipal,
};
